import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { useEnterprisePecaAiSearchProduct } from '@/core/domain/enterprise/pecaAi/pecaAi.hooks';
import { useDebounce } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useRef, useState } from 'react';

export interface PecaAiProductOption {
  value: number;
  label: string;
}

interface Props {
  value?: number | null;
  onChange?: (value: number, option: PecaAiProductOption) => void;
  onProductSelect?: (option: PecaAiProductOption) => void;
  disabled?: boolean;
}

export default function PecaAiDictionarySelect({
  onProductSelect,
  ...props
}: Props) {
  const [search, setSearch] = useState('');

  const searchDebounce = useDebounce(search, 500);

  const searchProducts = useEnterprisePecaAiSearchProduct({
    rows: 20,
    search: searchDebounce,
  });

  const products = flatInfiniteData(searchProducts.data);

  const options = products.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  const ref = useRef<BaseSelectRef>(null);

  const handleChange = (value: number, option: unknown) => {
    if (props.onChange) {
      props.onChange(value, option as PecaAiProductOption);
    }

    if (onProductSelect) {
      searchProducts.remove();
      setSearch('');
      onProductSelect(option as PecaAiProductOption);
      ref.current?.blur();
    }
  };

  return (
    <InfiniteSelect
      {...props}
      ref={ref}
      fetchNextPage={searchProducts.fetchNextPage}
      hasNextPage={searchProducts.hasNextPage}
      loading={searchProducts.isLoading}
      showSearch
      optionFilterProp="label"
      onChange={handleChange}
      options={options}
      searchValue={search}
      onSearch={setSearch}
      allowClear
    />
  );
}
